module.exports = __webpack_public_path__ + "media/bg-video.7b6eb355.mp4";